export class Coordinates {
  latitude: string;
  longitude: string;

  constructor(latitude: string, longitude: string) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
}

export interface GeoCoordinatesService {
  /**
   * Get the current user's coordinates based on data available in the browser.
   * @returns The user's coordinates if available, otherwise undefined.
   */
  getCoordinates(): Coordinates | undefined;
}
